
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import {required, requiredIf} from "vuelidate/lib/validators";

const ficheValidation = {
    $each: {
        id: {},
        provisionalBeginDate: {required},
        provisionalCompletionDate: {},
        workType: {required},
        activityArea: {required},
        ficheNumber: {required},
        period: {},
        precarityControl: {
            id: {},
            precarity: {required},
            bigPrecarity: {},
            coupleNumber: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_1', 'NO'].indexOf(precarityControl.precarity) < 0;
                    }
                })
            },
            coupleNumberInSocialHousing: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return precarityControl.precarity === 'CASE_2_BIS';
                    }
                })
            },
            couplePercentagePrecarity: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return precarityControl.precarity === 'CASE_3';
                    }
                })
            },
            couplePercentageBigPrecarity: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return precarityControl.precarity === 'CASE_3';
                    }
                })
            },
            coupleNumberPrecarity: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_2_BIS', 'CASE_4'].includes(precarityControl.precarity);
                    }
                })
            },
            coupleNumberBigPrecarity: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_2_BIS', 'CASE_4'].includes(precarityControl.precarity);
                    }
                })
            },
            periodId: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_2_BIS', 'CASE_2'].includes(precarityControl.precarity);
                    }
                })
            },
            department: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_2_BIS', 'CASE_2'].includes(precarityControl.precarity);
                    }
                })
            },
            couplePercentagePrecarityByDepartment: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_2_BIS', 'CASE_2'].includes(precarityControl.precarity);
                    }
                })
            },
            couplePercentageBigPrecarityByDepartment: {
                required: requiredIf(function (precarityControl) {
                    if (this.selectedFiche === null || this.selectedFiche < 0) {
                        return false;
                    } else {
                        return ['CASE_2_BIS', 'CASE_2'].includes(precarityControl.precarity);
                    }
                })
            },
        },
        workTypes: {},
        fiches: {},
        fiche: {},
        climateZone: {},
        departmentCode: {},
        conditions: {
            $each: {
                condition:{
                    id: {}
                },
                emmy: {
                    type: {},
                    listConditions: {},
                    name: {},
                    value: {
                        required
                    }
                },
            }
        },
        ficheEmmiesRemaining: {
            $each: {
                ficheEmmy: {
                    name: {},
                    id: {},
                    emmy: {
                        id: {},
                        listConditions: {},
                        type: {},
                        value: {}
                    },
                    type: {},
                    conditions: {},
                    enterable: {}
                },
                selectedValue: {},
                text: {},
                value: {}
            }
        },
        calculFormula: {
            libelle: {},
            ficheEmmies: {
                $each: {
                    id: {},
                    emmy: {
                        id: {},
                        listConditions: {},
                        type: {},
                        value: {},
                        name: {},
                        enterable: {}
                    },
                    conditions: {},
                    type: {},
                    enterable: {}
                }
            },
            ficheEmmiesRemaining: {
            $each: {
                ficheEmmy: {
                    name: {},
                    id: {},
                    emmy: {
                        id: {},
                        listConditions: {},
                        type: {},
                        value: {},
                        name: {}
                    },
                    type: {},
                    conditions: {},
                    enterable: {}
                },
                selectedValue: {},
                text: {},
                value: {}
            }
        },
            items: {
                $each: {
                    id: {},
                    name: {},
                    index: {},
                    ficheCalculItemFicheEmmies: {
                        $each: {
                            id: {},
                            ficheEmmy: {
                                id: {},
                                emmy: {
                                    id: {},
                                    type: {},
                                    listConditions: {},
                                    name: {},
                                    value: {
                                        required
                                    }
                                },
                                enterable: {}
                            },
                        }
                    },
                }
            }
        }
    }
}

export default ficheValidation;
